import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button } from 'telia-front-react';
import { useStores } from '../stores/RootStore';

const ReservationShowPreviewButton = observer((): React.JSX.Element => {
  const {
    reservationStore: {
      reservationCreationState: { status },
      validateFieldsAndShowPreview,
    },
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  return (
    <AnalyticsTrigger trigger={{ id: 'Button - Show appointment preview', callback: 'onClick' }}>
      <Button
        text={translate('reservation.forward')}
        onClick={() => validateFieldsAndShowPreview()}
        iconRight="#arrow-right"
        isLoading={status === 'SENDING'}
        disabled={status === 'SENDING'}
      />
    </AnalyticsTrigger>
  );
});

export default ReservationShowPreviewButton;
